import React from 'react';
import { BoxProps, CSSObject, Flex, Text } from '@chakra-ui/react';

type DashedFlexProps = { children: React.ReactNode } & BoxProps;

const dashPseduo: CSSObject = {
  content: `""`,
  borderBottom: '1px solid',
  display: 'flex',
  mx: '12px',
  borderColor: 'scheme.backgroundSecondary',
  flex: 1
};

export const DashedFlex: React.FC<DashedFlexProps> = ({ children, ...rest }) => (
  <Flex align="center" w="100%" my="8px" _before={dashPseduo} _after={dashPseduo} {...rest}>
    {children}
  </Flex>
);
